<template>
  <div class="col-auto header" :class="props.class" :style="props.style">
    <div class="row items-center no-wrap q-pt-xs q-pb-none q-px-md">
      <q-btn
        v-if="props.backButton && !props.hideCloseButton"
        icon="chevron_left"
        size="md"
        round
        flat
        style="margin-left: -8px"
        @click="dialog?.onDialogCancel()"
      />
      <q-icon
        v-if="props.icon"
        :name="props.icon"
        size="sm"
        color="black"
        class="q-mr-xs"
        style="margin-top: -4px"
      />
      <slot></slot>
      <template v-if="!props.backButton && !props.hideCloseButton">
        <q-space />
        <q-btn
          icon="close"
          size="md"
          round
          flat
          @click="dialog?.onDialogCancel()"
        />
      </template>
    </div>
    <slot name="bottom"></slot>
  </div>
</template>

<script setup lang="ts">
import { inject } from "vue";
import { dialogInjectionKey } from ".";

const props = withDefaults(
  defineProps<{
    icon?: string;
    backButton?: boolean;
    hideCloseButton?: boolean;
    class?: string;
    style?: string;
  }>(),
  {
    backButton: false,
    hideCloseButton: false,
    class: "",
    style: "",
  },
);

const dialog = inject(dialogInjectionKey);
</script>

<style scoped lang="scss">
@import "@/scss/colors";

.header {
  background: $yellow-darker !important;
  border-bottom: 1px solid rgb(0 0 0 / 10%);
}
</style>
